// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyAJiSgCkI5TJAWkYtAkfmx-laEhVZhmuR4',
  authDomain: 'globaltalent-a51be.firebaseapp.com',
  databaseURL: 'https://globaltalent-a51be.firebaseio.com',
  projectId: 'globaltalent-a51be',
  storageBucket: 'globaltalent-a51be.appspot.com',
  messagingSenderId: '715460143763',
  appId: '1:715460143763:web:f565cc2a4b38838aad7b66',
  measurementId: 'G-KTY38YSMHS',
};
